import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from "./shared/login.service";
import { formatDate } from "@angular/common";
import { DatePipe } from '@angular/common';

import { ToasterserviceService } from "../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  pipe = new DatePipe('en-US');
  ErrorText: string;
  toast: Toastpayload;
  UserIP:string;
  Loading: boolean= false;

  constructor(private router: Router, public loginService: LoginService,
    private toasterserviceService: ToasterserviceService,
    private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {
  }

  public UserLogin(UName, Upassword) {

    this.toast = {
      message: "No Message Now!",
      title: 'User Login',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };
    
    if (UName != null && Upassword != null) {
      this.loginService.selectedEmployee.UserName = UName;
      this.loginService.selectedEmployee.Password = Upassword;

      // showing Loader 
      this.ngxLoader.start();

      // Client Ip Address
      // this.loginService.getUserIPLocation().subscribe(data => {
      //   this.UserIP = data['ip']; 
      //   console.log(this.UserIP);
      //   console.log(data)
      // })
      this.Loading = true;  // loading spinner 
      let IsLoginPromise = this.LoginUser();

          IsLoginPromise.then((val) => {
            if (val) {
              this.toasterserviceService.showToast(this.toast);
              this.router.navigate(['/dashboard']);
            }
          });

      // Closing Loader
      this.ngxLoader.stop(); 
    }
  }

  // login user using promise()
  LoginUser(){
    let promise = new Promise((resolve,reject) => {

      this.loginService.FetchLogin(this.loginService.selectedEmployee)
      .toPromise()
      .then(res => {

        if (res != null) {
          
          // console.log(JSON.stringify(res));
          localStorage.setItem("IsLoggedIn", "true");
          localStorage.setItem("EmployeeData", JSON.stringify(res));
          // localStorage.setItem("EmployeeToken", res.Token.data);

          // localStorage.setItem("EmployeeId", res.Id);
          // localStorage.setItem("EmpUserName", res.UserName);
          // localStorage.setItem("EmpBranchId", res.BranchId);
          // localStorage.setItem("EmployeeBranchName", res.EmployeeBranchName);
          // localStorage.setItem("EmpCompanyId", res.CompanyId);
          // localStorage.setItem("EmpSaasId", res.SaasId);
          // localStorage.setItem("DesignationId", res.DesignationId);
          // localStorage.setItem("DesignationName", res.DesignationName);

          // const dateFormat = 'dd/MM/yyyy';
          // const ApplicationDate = this.pipe.transform((res.ApplicationDate), dateFormat)
          // localStorage.setItem("ApplicationDate",ApplicationDate);  // System Date

          const format = 'MMM d, y';
          const systemDate = res.ApplicationDate;
          const locale = 'en-US';
          const formattedDate = formatDate(systemDate, format, locale);
          // localStorage.setItem("ApplicationDate",formattedDate);  // System Date

          var appObj = JSON.parse(localStorage.getItem("EmployeeData")); // to loantransaction
          appObj.ApplicationDate = formattedDate;
          localStorage.setItem("EmployeeData", JSON.stringify(appObj));

          // console.log(formattedDate);
          // let dateString = '02/05/2020';  
          // let momentVariable = moment(dateString, 'MM-DD-YYYY');  
          // let stringvalue = momentVariable.format('YYYY-MM-DD');   
          // console.log(stringvalue); // outputs 2020-05-02  
          // localStorage.setItem("CreatedDate", formattedDate);
          // localStorage.setItem("ModifiedDate", formattedDate);

          this.toast.title =  'Welcome!. ' + res.UserName + ',';
          this.toast.message = 'You are successfully logged in.'
          this.toast.type = 'success';
          // this.toasterserviceService.showToast(this.toast);

          // this.router.navigate(['/dashboard']);
          resolve(true)
        }
        else {
          // this.ErrorText = "Incorrect Name or Password."
          this.Loading = false;
          this.toast.message = 'Sorry, you have entered an invalid Username or Password. Please try again.'
          this.toast.type = 'error';
          this.toasterserviceService.showToast(this.toast);
          this.ngxLoader.stop(); 

          reject(false)
        }
      })
      .catch(err => {
  
        this.ErrorText = "Sorry, you have entered an invalid username or password. Please try again."
        this.Loading = false;
      });
    })

    return promise;
    }

    // while pressing the enter button
    onEnter(UName: string, Upassword:string) {

      this.UserLogin(UName, Upassword)
    }
    

}
